import React from 'react'
import { Button } from 'hhsoig-design-system-core'

export const ProtectedCommunicationWarning = () => {
  return (
    <div>
      <h2>You may not be a protected whistleblower</h2>
      <p>
        The options provided on the previous page are the only entities that are
        legally recognized as the recipients of a protected communication.
      </p>
      <Button
        variation="primary"
        data-testid="return-to-hhs-tips"
        href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      >
        Return to HHS-OIG Hotline
      </Button>
      <h4>If you wish to proceed</h4>
      <p>
        I acknowledge that I’ve read and understood that by selecting other, I
        may not be a protected whistleblower under HHS-OIG's jurisdiction.
      </p>
    </div>
  )
}
